import {Input, message} from 'antd';
import {ProModal, ProModalProps} from 'Components/ProModal';
import ProForm from '../../../../ProForm';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {errorMessage, isTrue} from 'Utils/common';
import {changePwd} from '../../../../../Services/user';
import useRequest from '../../../../../Utils/Hooks/useRequest';
import {getNormalLoginSetting} from '../../../../../Pages/System/LoginSettings/service';
import {RuleObject, StoreValue} from 'rc-field-form/lib/interface';
import lodash from 'lodash-es';

interface PassForm {
    oldPassword: string;
    password: string;
    confirmPassword: string;
}

export function EditPassModal({onOk, ...props}: ProModalProps) {
    const [loginSetting, settingStatus] = useRequest(getNormalLoginSetting);

    const [onFinish] = useRequestFn(async (data: PassForm) => {
        const {confirmPassword, ...pwdData} = lodash.cloneDeep(data);
        if (data.password !== confirmPassword) {
            message.error('两次密码输入必须一致');
            return;
        }

        try {
            await changePwd(pwdData);
            message.success('修改成功!');
            onOk?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const checkTypes = [
        isTrue(loginSetting?.lowerCase) ? '小写字母' : undefined,
        isTrue(loginSetting?.upperCase) ? '大写字母' : undefined,
        isTrue(loginSetting?.numberCase) ? '数字' : undefined,
        isTrue(loginSetting?.specificSymbol) ? '特殊符号' : undefined,
    ].filter(item => !!item);

    function validatePwd() {
        return {
            validator: (rule: RuleObject, value: StoreValue) => {
                value = lodash.cloneDeep(value);
                if (isTrue(loginSetting?.lowerCase) && !/[a-z]/.test(value))
                    return Promise.reject();
                if (isTrue(loginSetting?.upperCase) && !/[A-Z]/.test(value))
                    return Promise.reject();
                if (isTrue(loginSetting?.numberCase) && !/[0-9]/.test(value))
                    return Promise.reject();
                if (
                    isTrue(loginSetting?.specificSymbol) &&
                    !/[~!@#$%^&*\-_+=|\\<>,.?/]/.test(value)
                )
                    return Promise.reject();
                return Promise.resolve();
            },
            message: `密码必须包含${checkTypes.join('、')}`,
        };
    }

    return (
        <ProModal.Form
            {...props}
            onFinish={onFinish}
            title="修改密码"
            width={750}
            loading={settingStatus.loading}
            formProps={{columns: 1, wrapperCol: {span: 16}}}>
            <ProForm.Field
                name="oldPassword"
                label="旧密码"
                required
                rules={[{required: true, message: '${label}不能为空'}]}>
                <Input.Password />
            </ProForm.Field>

            <ProForm.Field
                name="password"
                label="新密码"
                required
                rules={[
                    {required: true, message: '${label}不能为空'},
                    {
                        type: 'string',
                        min: Number(loginSetting?.lengthMin),
                        max: Number(loginSetting?.lengthMax),
                        message: `密码长度必须在${loginSetting?.lengthMin}-${loginSetting?.lengthMax}位之间`,
                    },
                    validatePwd,
                ]}>
                <Input.Password
                    placeholder={`请输入 ${loginSetting?.lengthMin}-${
                        loginSetting?.lengthMax
                    } 个字符且包含${checkTypes.join('、')}`}
                />
            </ProForm.Field>

            <ProForm.Field
                name="confirmPassword"
                label="确认新密码"
                required
                rules={[{required: true, message: '${label}不能为空'}]}>
                <Input.Password />
            </ProForm.Field>
        </ProModal.Form>
    );
}
